import { authorizedRequest } from "utils/api";
import { ToastError } from "components/Global/Toasts/Toasty";

export const getOnboardingGuideCxToken = async () => {
  try {
    return await authorizedRequest("/onboarding");
  } catch (err) {
    ToastError("Something went wrong");
    throw err;
  }
};
